import Cookies from 'js-cookie';

import { apiFetch, markSessionRefreshBaseline } from './apiClient';

import {

  JWT_KEY,

  JWT_EXPIRES_KEY,

  MODULES_KEY,

  clearPersistedSession,

  getSessionItem,

  getSessionModules,

  setSessionItem,

} from './sessionStore';



const LEGACY_AUTH_HEADER = 'U2lzdGVtYUdlc3Rpb25BbHVtbm9zX1BJQUdFVF8yMDIy';



export function getLegacyAuthorizationHeader() {

  return LEGACY_AUTH_HEADER;

}



/** @deprecated Use getAuthorizationHeader() — mantiene compatibilidad con tests Bloque 11 */

export const AuthorizationHeader = LEGACY_AUTH_HEADER;



export async function login(username, password) {

  return apiFetch('api/User/Authenticate', {

    method: 'POST',

    body: JSON.stringify({ username, password }),

  });

}



export function storeSession(loginResponse, username) {

  const model = loginResponse.returnModel;

  if (!model || !model.modulos || model.modulos.length === 0) {

    return false;

  }



  Cookies.set('authToken', 'true');

  Cookies.set('username', username);

  Cookies.set('alumnoCodigos', JSON.stringify(model.carrerasId || []));



  if (model.token) {

    setSessionItem(JWT_KEY, model.token);

    if (model.expiresAtUtc) {

      setSessionItem(JWT_EXPIRES_KEY, model.expiresAtUtc);

    }

    markSessionRefreshBaseline();

  }



  setSessionItem(MODULES_KEY, JSON.stringify(model.modulos));

  window.dispatchEvent(new CustomEvent('authenticated'));

  return true;

}



export function getAuthorizationHeader() {

  const jwt = getSessionItem(JWT_KEY);

  if (jwt && !isJwtExpired()) {

    return `Bearer ${jwt}`;

  }

  return null;

}

export function hasValidJwt() {
  const jwt = getSessionItem(JWT_KEY);
  return Boolean(jwt && !isJwtExpired());
}

export function isPublicAuthUrl(url) {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const normalized = url.toLowerCase();
  return normalized.includes('api/user/authenticate');
}

export function isRefreshSessionUrl(url) {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const normalized = url.toLowerCase();
  return normalized.includes('api/user/refreshsession');
}

export function updateSessionToken(token, expiresAtUtc) {
  setSessionItem(JWT_KEY, token);
  if (expiresAtUtc) {
    setSessionItem(JWT_EXPIRES_KEY, expiresAtUtc);
  }
}

export function getJwtTimeRemainingMs() {
  const expires = getSessionItem(JWT_EXPIRES_KEY);
  if (!expires) {
    return Number.POSITIVE_INFINITY;
  }
  return new Date(expires).getTime() - Date.now();
}



export function getApiHeaders(extra = {}) {
  const authorization = getAuthorizationHeader();
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...extra,
  };

  if (authorization) {
    headers.Authorization = authorization;
  }



  const username = Cookies.get('username');

  if (username) {

    headers.Username = username;

  }



  return headers;

}



export function isJwtExpired() {

  const expires = getSessionItem(JWT_EXPIRES_KEY);

  if (!expires) {

    return false;

  }

  return new Date(expires).getTime() <= Date.now();

}



/** Sesión válida: cookie de auth + permisos persistidos + JWT no vencido. */

export function isAuthenticated() {

  if (Cookies.get('authToken') !== 'true') {

    return false;

  }

  if (isJwtExpired()) {

    return false;

  }

  return getSessionModules().length > 0;

}



/** Cookie de login sin datos de sesión (estado inconsistente). */

export function hasStaleAuthCookie() {

  return Cookies.get('authToken') === 'true' && !isAuthenticated();

}



export function clearSession() {

  Cookies.set('authToken', 'false');

  Cookies.set('alumnoCodigos', '');

  Cookies.remove('username');

  clearPersistedSession();

  window.dispatchEvent(new CustomEvent('authenticated'));

}



export function logout() {

  clearSession();

  window.dispatchEvent(new CustomEvent('logout'));

}


